import React, { useState, useRef, useEffect } from "react";
import { rolesForm } from "./RolesData";
import { AiOutlineClose } from "react-icons/ai";
import CustomButton from "../../../Components/Common/CustomButton";
import CustomInput from "../../../Components/Common/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { updateTenant } from "../../../redux/roles/rolesSlice";
import { fetchLocations } from "../../../redux/locations/locationSlice";
import Loading from "../../../Components/Common/Loading";
import CommonLocationSelect from "../../../Components/Common/CommonLocationSelect";
import toast from "react-hot-toast";

const CreateRoles = ({ showForm, setShowForm }) => {
  const dispatch = useDispatch();
  const [rolesData, setRolesData] = useState({
    description: "",
    Name: "",
    allowedAppsActions: [
      {
        appName: "PractitionerApp",
        permissions: {
          Worklist: {
            read: false,
            write: false,
            delete: false,
          },
          Patients: {
            read: false,
            write: false,
            delete: false,
          },
          Calendar: {
            read: false,
            write: false,
            delete: false,
          },
          Billing: {
            read: false,
            write: false,
            delete: false,
          },
          "Profile Management": {},
          Personal: {
            read: false,
            write: false,
            delete: false,
          },
          Contact: {
            read: false,
            write: false,
            delete: false,
          },
          Work: {
            read: false,
            write: false,
            delete: false,
          },
          Service: {
            read: false,
            write: false,
            delete: false,
          },
          Roster: {
            read: false,
            write: false,
            delete: false,
          },
          "Health Records": {},
          Vitale: {
            read: false,
            write: false,
            delete: false,
          },
          MedicalHistory: {
            read: false,
            write: false,
            delete: false,
          },
          FamilyMemberHistory: {
            read: false,
            write: false,
            delete: false,
          },
          SurgicalHistory: {
            read: false,
            write: false,
            delete: false,
          },
          Allergies: {
            read: false,
            write: false,
            delete: false,
          },
          Diagnosis: {
            read: false,
            write: false,
            delete: false,
          },
          Medications: {
            read: false,
            write: false,
            delete: false,
          },
          Orders: {
            read: false,
            write: false,
            delete: false,
          },
          Procedures: {
            read: false,
            write: false,
            delete: false,
          },
          ChiefComplaints: {
            read: false,
            write: false,
            delete: false,
          },
          PastHealthRecords: {
            read: false,
            write: false,
            delete: false,
          },
        },
      },
      {
        appName: "AdminApp",
        permissions: {
          Location: {
            read: false,
            write: false,
            delete: false,
          },
          RosterManagement: {
            read: false,
            write: false,
            delete: false,
          },
          UserManagement: {
            read: false,
            write: false,
            delete: false,
          },
          RolesPermissions: {
            read: false,
            write: false,
            delete: false,
          },
          TenantSettings: {
            read: false,
            write: false,
            delete: false,
          },
          OrganizationManagement: {
            read: false,
            write: false,
            delete: false,
          },
          WardManagement: {
            read: false,
            write: false,
            delete: false,
          },
          PharmacyManagement: {
            read: false,
            write: false,
            delete: false,
          },
          DiagnosticManagement: {
            read: false,
            write: false,
            delete: false,
          },
          BillingManagement: {
            read: false,
            write: false,
            delete: false,
          },
        },
      },
    ],
  });

  const [invalidFields, setInvalidFields] = useState({});
  const [loading, setLoading] = useState(false);
  const { locations } = useSelector((state) => state.locations); 
  const [errorMessage, setErrorMessage] = useState("");
  const formRef = useRef();
  const { tenant } = useSelector((state) => state.tenant);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (formRef.current && !formRef.current.contains(event.target)) {
        setShowForm(false);
      }
    };

    if (showForm) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, [showForm]);

  const handleChange = (name, value) => {
    setRolesData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setInvalidFields((prevInvalidFields) => ({
      ...prevInvalidFields,
      [name]: false,
    }));
  };

  const handleLocationChange = (location) => {
    setRolesData((prevData) => ({
      ...prevData,
      location,
    }));
    setInvalidFields((prevInvalidFields) => ({
      ...prevInvalidFields,
      location: false,
    }));
  };

  const handleLocationClear = () => {
    setRolesData((prevData) => ({
      ...prevData,
      location: null,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newInvalidFields = {
      ...Object.fromEntries(
        Object.keys(rolesData).map((key) => {
          if (typeof rolesData[key] === "string") {
            return [key, rolesData[key].trim() === ""];
          }
          return [key, false];
        })
      ),
      location: !rolesData.location,
    };

    setInvalidFields(newInvalidFields);
    setErrorMessage("");

    if (Object.values(newInvalidFields).every((isInvalid) => !isInvalid)) {
      setLoading(true);

      const newRole = {
        role: rolesData.Name,
        locationName: rolesData.location.name,
        locationId: rolesData.location._id,
        description: rolesData.description,
        allowedAppsActions: rolesData.allowedAppsActions
      };

      const { roles } = tenant;
      const updatedRoles = [...roles, newRole];
      const data = { roles: updatedRoles };

      try {
        const response = await dispatch(updateTenant({ data })).unwrap();
  
        setShowForm(false);
        toast.success("Role created successfully!");
        setRolesData({
          description: "",
          Name: "",
          allowedAppsActions: [
            {
              appName: "PractitionerApp",
              permissions: {
                Worklist: {
                  read: false,
                  write: false,
                  delete: false,
                },
                Patients: {
                  read: false,
                  write: false,
                  delete: false,
                },
                Calendar: {
                  read: false,
                  write: false,
                  delete: false,
                },
                Billing: {
                  read: false,
                  write: false,
                  delete: false,
                },
                "Profile Management": {},
                Personal: {
                  read: false,
                  write: false,
                  delete: false,
                },
                Contact: {
                  read: false,
                  write: false,
                  delete: false,
                },
                Work: {
                  read: false,
                  write: false,
                  delete: false,
                },
                Service: {
                  read: false,
                  write: false,
                  delete: false,
                },
                Roster: {
                  read: false,
                  write: false,
                  delete: false,
                },
                "Health Records": {},
                Vitale: {
                  read: false,
                  write: false,
                  delete: false,
                },
                MedicalHistory: {
                  read: false,
                  write: false,
                  delete: false,
                },
                FamilyMemberHistory: {
                  read: false,
                  write: false,
                  delete: false,
                },
                SurgicalHistory: {
                  read: false,
                  write: false,
                  delete: false,
                },
                Allergies: {
                  read: false,
                  write: false,
                  delete: false,
                },
                Diagnosis: {
                  read: false,
                  write: false,
                  delete: false,
                },
                Medications: {
                  read: false,
                  write: false,
                  delete: false,
                },
                Orders: {
                  read: false,
                  write: false,
                  delete: false,
                },
                Procedures: {
                  read: false,
                  write: false,
                  delete: false,
                },
                ChiefComplaints: {
                  read: false,
                  write: false,
                  delete: false,
                },
                PastHealthRecords: {
                  read: false,
                  write: false,
                  delete: false,
                },
              },
            },
            {
              appName: "AdminApp",
              permissions: {
                Location: {
                  read: false,
                  write: false,
                  delete: false,
                },
                RosterManagement: {
                  read: false,
                  write: false,
                  delete: false,
                },
                UserManagement: {
                  read: false,
                  write: false,
                  delete: false,
                },
                RolesPermissions: {
                  read: false,
                  write: false,
                  delete: false,
                },
                TenantSettings: {
                  read: false,
                  write: false,
                  delete: false,
                },
                OrganizationManagement: {
                  read: false,
                  write: false,
                  delete: false,
                },
                WardManagement: {
                  read: false,
                  write: false,
                  delete: false,
                },
                PharmacyManagement: {
                  read: false,
                  write: false,
                  delete: false,
                },
                DiagnosticManagement: {
                  read: false,
                  write: false,
                  delete: false,
                },
                BillingManagement: {
                  read: false,
                  write: false,
                  delete: false,
                },
              },
            },
          ],
        });
      } catch (error) {
        toast.error("Failed to update:", error);
        setErrorMessage("Update failed: " + error.message);
      } finally {
        setLoading(false);
      }
    } else {
      console.log("Invalid fields:", newInvalidFields);
    }
  };

useEffect(() => {
    dispatch(fetchLocations({ currentPage: null, itemsPerPage: null }));
  }, [dispatch]);

return (
  <div className="fixed z-10 inset-0 overflow-y-auto">
    <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div className="fixed inset-0 transition-opacity" aria-hidden="true">
        <div className="absolute inset-0 bg-gray-900/10 backdrop-blur-[1.5px]" />
      </div>
      <span
        className="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
      >
        &#8203;
      </span>
      <div
        ref={formRef}
        className="inline-block align-bottom bg-white shadow-lg pb-10 pl-4 pt-2 text-left rounded-xl transform transition-all sm:my-8 sm:align-middle w-full max-w-[36rem]"
      >
        <div className="relative bg-white rounded-xl">
          <button
            onClick={() => setShowForm(false)}
            className="absolute top-2 right-2 text-2xl text-brand-500 rounded px-3 py-2"
            aria-label="Close"
          >
            <AiOutlineClose />
          </button>
          <div className="h-full py-6 overflow-y-hidden">
            <h1 className="text-xl font-semibold ml-4">Add Roles</h1>
            {errorMessage && (
              <div className="text-red-500 ml-4">{errorMessage}</div>
            )}
            <div className="px-4 mt-4 flex flex-col gap-4 text-black">
            <div className={invalidFields.location ? "border-red-500" : ""}>
                <CommonLocationSelect
                  locations={locations || []}
                  value={rolesData.location}
                  onChange={handleLocationChange}
                  onClear={handleLocationClear}
                />
                {invalidFields.location && (
                  <p className="text-red-500 text-sm mt-1">Location is required</p>
                )}
              </div>
              {rolesForm.map(({ id, type, label, placeholder }) => (
                <CustomInput
                  key={id}
                  type={type}
                  label={label}
                  id={id}
                  placeholder={placeholder}
                  value={rolesData[id] || ""}
                  isInvalid={invalidFields[id]}
                  onchange={(e) => handleChange(id, e.target.value)}
                />
              ))}
            </div>
            {loading ? (
              <div className="flex justify-center mt-4">
                <Loading size="12" color="brand-500" />
              </div>
            ) : (
              <div className="flex justify-end absolute -bottom-5 right-8 w-auto">
                <CustomButton
                  type="button"
                  text={loading ? "Saving..." : "Save"}
                  onClick={handleSubmit}
                  disabled={loading}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);
};

export default CreateRoles;
